export const Types = {
  setStep: 'stepper/SET_STEP'
}

export function setStep ({ step } = {}) {
  return {
    type: Types.setStep,
    payload: { step }
  }
}
